// extracted by mini-css-extract-plugin
export default {"AppStoreLinks":"AppStoreLinks_AppStoreLinks__-iZ3d"};